var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',{staticClass:"setItems__item"},[_c('td',[_vm._v(_vm._s(_vm.quantity)+"x")]),_c('td',{staticClass:"flex-grow-1 ml-2",attrs:{"colspan":"9"}},[_vm._v(_vm._s(_vm.$t('components.BasketPackGift.gift'))+" "+_vm._s(_vm.name))])])}
var staticRenderFns = []

export { render, staticRenderFns }